export default "__VITE_ASSET__C01U0Uub__"